/**
 * 客服助手显隐偏好（与 holopix-support Widget 对齐）
 * localStorage key / 事件名必须与 packages/widget/src/visibility.js 一致
 */

export const SUPPORT_ASSISTANT_DISABLED_KEY = "hpx-assistant-disabled";
export const SUPPORT_ASSISTANT_VISIBILITY_EVENT = "hpx-assistant-visibility";

type VisibilityListener = (enabled: boolean) => void;

declare global {
  interface Window {
    HolopixSupport?: {
      setAssistantEnabled?: (enabled: boolean) => void;
      isAssistantEnabled?: () => boolean;
    };
  }
}

/** 当前是否显示客服助手（默认开启） */
export function isSupportAssistantEnabled(): boolean {
  if (typeof window !== "undefined" && typeof window.HolopixSupport?.isAssistantEnabled === "function") {
    return window.HolopixSupport.isAssistantEnabled();
  }
  try {
    return localStorage.getItem(SUPPORT_ASSISTANT_DISABLED_KEY) !== "1";
  } catch {
    return true;
  }
}

/**
 * 设置客服助手显隐。
 * 优先走 Widget 公开 API，保证与挂件内「停用助手」共用同一套状态。
 */
export function setSupportAssistantEnabled(enabled: boolean): void {
  if (typeof window !== "undefined" && typeof window.HolopixSupport?.setAssistantEnabled === "function") {
    window.HolopixSupport.setAssistantEnabled(enabled);
    return;
  }
  try {
    localStorage.setItem(SUPPORT_ASSISTANT_DISABLED_KEY, enabled ? "0" : "1");
  } catch {
    /* 无 storage 时仍派发事件，更新当前页 */
  }
  window.dispatchEvent(new CustomEvent(SUPPORT_ASSISTANT_VISIBILITY_EVENT, { detail: Boolean(enabled) }));
}

/** 订阅显隐变化（同页 CustomEvent + 跨 tab storage） */
export function subscribeSupportAssistantVisibility(callback: VisibilityListener): () => void {
  const onCustom = (e: Event) => {
    const detail = (e as CustomEvent<boolean>).detail;
    callback(typeof detail === "boolean" ? detail : isSupportAssistantEnabled());
  };
  const onStorage = (e: StorageEvent) => {
    if (e.key === SUPPORT_ASSISTANT_DISABLED_KEY || e.key === null) {
      callback(isSupportAssistantEnabled());
    }
  };
  window.addEventListener(SUPPORT_ASSISTANT_VISIBILITY_EVENT, onCustom);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(SUPPORT_ASSISTANT_VISIBILITY_EVENT, onCustom);
    window.removeEventListener("storage", onStorage);
  };
}
